module.exports = __webpack_public_path__ + "static/media/pdf.f9928ae4.svg";